<template>
    <section id="loginDiv">
        <div class="container mt-5">
            <!-- Jumbotron -->
            <div class="px-4 py-5 px-md-5 text-center text-lg-start loginContain">
                <div class="container">
                    <div class="row gx-lg-5 align-items-center">
                        <div class="col-lg-6 mb-5 mb-lg-0">
                            <img class="pt-7 pt-md-0 hero-img" src="../../assets/img/reg.png">
                            <h1 class="my-5 display-3 fw-bold ls-tight">
                                The best offer <br />
                                <span class="text-primary">for your business</span>
                            </h1>
                            <p style="color: hsl(217, 10%, 50.8%)">
                                Lorem ipsum dolor sit amet consectetur adipisicing elit.
                                Eveniet, itaque accusantium odio, soluta, corrupti aliquam
                                quibusdam tempora at cupiditate quis eum maiores libero
                                veritatis? Dicta facilis sint aliquid ipsum atque?
                            </p>
                        </div>

                        <div class="col-lg-6 mb-5 mb-lg-0">
                            <div class="card" style="background-color: #f8f8f8;">
                                <div class="card-body py-5 px-md-5" id="loginBox">

                                    <!-- Email input -->
                                    <div data-mdb-input-init class="form-outline mb-4">
                                        <label class="form-label" for="userName">Email address</label>
                                        <input type="email" id="userName" name="userName"
                                            class="form-control borderR" />
                                        <small class="text-danger" id="loginUserError"></small>
                                    </div>

                                    <!-- Password input -->
                                    <div data-mdb-input-init class="form-outline mb-4">
                                        <label class="form-label" for="lPassword">Password</label>
                                        <input type="password" id="lPassword" name="lPassword"
                                            class="form-control borderR" />
                                        <small class="text-danger" id="loginPasswordError"></small>
                                    </div>

                                    <div class="alert alert-danger d-none" role="alert" id="loginError">
                                        Please check your user name or password!
                                    </div>

                                    <!-- Submit button -->
                                    <div data-mdb-input-init class="form-outline mt-5">
                                        <label class="form-label" for="form3Example4"></label>
                                        <button class="col-md-12 btn btn-medium btn-info" id="loginBtn">Login</button>
                                    </div>
                                    <div>
                                        <!-- Checkbox -->
                                        <div class="form-check d-flex justify-content-start mt-4">
                                            <input class="form-check-input" type="checkbox" value=""
                                                id="form1Example3" />
                                            <a href=""><label class="form-check-label" for="form1Example3"
                                                    style="padding-left: 10px;">
                                                    Remember password</label></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Section: Design Block -->
            </div>
        </div>
    </section>
</template>

<script>

import $ from 'jquery';
import Swal from 'sweetalert2';

export default {
    name: 'LoginPage',
    mounted() {
        this.initializeEventListeners();

        const queryParams = new URLSearchParams(window.location.search);
        const email = queryParams.get('email');


        if (email) {
            Swal.fire({
                title: 'Verifying Email',
                html: `Email: <strong>${email}</strong><br><br>Verification will start in <b></b> seconds.`,
                icon: 'info',
                timer: 5000,
                timerProgressBar: true,
                allowOutsideClick: false,
                allowEscapeKey: false,
                didOpen: () => {
                    const b = Swal.getHtmlContainer().querySelector('b');
                    let timerInterval = setInterval(() => {
                        const timeLeft = Math.ceil(Swal.getTimerLeft() / 1000);
                        b.textContent = timeLeft;
                    }, 1000);
                    Swal.showLoading();
                },
            }).then(() => {
                this.verifyCustomer(email);
            });
        }

    },
    methods: {
        customerLogin() {
            // Retrieve input values
            const userName = $('#userName').val().trim();
            const password = $('#lPassword').val().trim();

            // Clear previous error messages
            $('#loginError').text('').addClass('d-none');

            // Basic validation
            if (!userName || !password) {
                $('#loginError').text('Username and password are required.').removeClass('d-none');
                return;
            }

            // AJAX request using jQuery
            $.ajax({

                url: process.env.VUE_APP_API_URL + '/customerLogin', // No need to add baseUrl manually
                method: 'POST',
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content') // Include CSRF token if needed
                },
                data: {
                    userName: userName,
                    password: password,
                },
                beforeSend: function () {
                    // Show the loading screen before sending the request
                    $('#loadingScreen').removeClass('d-none');
                },
                success: function (response) {
                    if (response.success) {
                        // Store customer info and token in localStorage
                        localStorage.setItem('user', JSON.stringify(response.customer));
                        localStorage.setItem('token', response.token);


                        // Retrieve the stored redirect path and booking details
                        const redirectPath = localStorage.getItem('redirectPath');
                        // Parse the stored JSON string for placeDetails
                        const placeDetails = JSON.parse(localStorage.getItem('placeDetails'));
                        const bookingDetails = JSON.parse(localStorage.getItem('bookingDetails'));

                        const apiPackageCheck = localStorage.getItem('redirectAfterLogin');

                        // Redirect to the original page or wherever necessary
                        if (redirectPath) {
                            localStorage.removeItem('redirectPath');
                            const queryParams = new URLSearchParams({
                                adults: bookingDetails.adults,
                                children: bookingDetails.children,
                                checkIn: bookingDetails.checkIn,
                                checkOut: bookingDetails.checkOut,
                                place: JSON.stringify(placeDetails)
                            }).toString();

                            window.location.href = `/booking?${queryParams}`;
                        }
                        else if (apiPackageCheck) {
                            window.location.href = apiPackageCheck;
                        }
                        else {
                            window.location.href = '/'; // Default redirect if no path is stored
                        }

                    } else {
                        // Handle specific error messages from the server
                        $('#loginError').text(response.message || 'Login failed.').removeClass('d-none');
                    }
                },
                error: function (xhr, status, error) {
                    // Hide the loading screen
                    $('#loadingScreen').addClass('d-none');
                    console.error('Login error:', status, error);

                    // Check if the response contains a 'message' property
                    if (xhr.responseJSON && xhr.responseJSON.message) {
                        // Show the message from the response in #loginError
                        $('#loginError').text(xhr.responseJSON.message).removeClass('d-none');
                    } else {
                        // Display a fallback generic error message if no 'message' is provided
                        $('#loginError').text('An error occurred. Please try again.').removeClass('d-none');
                    }
                },
                complete: function () {
                    // Hide the loading screen
                    $('#loadingScreen').addClass('d-none');
                }
            });
        },

        verifyCustomer(email) {
            $.ajax({
                url: process.env.VUE_APP_API_URL + '/verify-customer/' + email,
                method: 'GET',
                beforeSend: function () {
                    $('#loadingScreen').removeClass('d-none');
                },
                success: function (response) {
                    let title = 'Success';
                    let icon = 'success';

                    switch (response.code) {
                        case 200:
                            title = 'Success';
                            icon = 'success';
                            break;
                        case 400:
                            title = 'Bad Request';
                            icon = 'warning';
                            break;
                        case 404:
                            title = 'Not Found';
                            icon = 'error';
                            break;
                        case 410:
                            title = 'Expired';
                            icon = 'info';
                            break;
                        case 500:
                            title = 'Server Error';
                            icon = 'error';
                            break;
                        default:
                            title = 'Error';
                            icon = 'error';
                    }

                    Swal.fire({
                        title: title,
                        text: response.message,
                        icon: icon,
                        confirmButtonText: 'OK'
                    });

                    // Optional: set userName if success
                    if (response.code === 200) {
                        $('#userName').val(email);
                    }
                },
                error: function (xhr) {
                    let message = 'An error occurred.';
                    let code = xhr.status;

                    if (xhr.responseJSON) {
                        message = xhr.responseJSON.message || message;
                        code = xhr.responseJSON.code || xhr.status;
                    }

                    let title = 'Error';
                    let icon = 'error';

                    switch (code) {
                        case 400:
                            title = 'Bad Request';
                            icon = 'warning';
                            break;
                        case 404:
                            title = 'Not Found';
                            icon = 'error';
                            break;
                        case 410:
                            title = 'Expired';
                            icon = 'info';
                            break;
                        case 500:
                            title = 'Server Error';
                            icon = 'error';
                            break;
                    }

                    Swal.fire({
                        title: title,
                        text: message,
                        icon: icon,
                        confirmButtonText: 'OK'
                    });
                },
                complete: function () {
                    $('#loadingScreen').addClass('d-none');
                }
            });
        }
        ,
        initializeEventListeners() {
            const self = this;

            $('#loginBtn').click(function () {
                // Clear previous error messages
                const loginUserError = $('#loginUserError');
                const loginPasswordError = $('#loginPasswordError');

                loginUserError.text('').removeClass('text-danger text-success');
                loginPasswordError.text('').removeClass('text-danger text-success');

                // Initialize validation flag
                let isValid = true;

                // Retrieve form values
                const userName = $('#userName').val();
                const password = $('#lPassword').val();

                // Email validation
                const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                if (userName && !emailPattern.test(userName)) {
                    loginUserError.text('Please enter a valid email address.').addClass('text-danger');
                    isValid = false;
                }

                // Username validation
                if (userName === '') {
                    loginUserError.text('Username is required.').addClass('text-danger');
                    isValid = false;
                }

                // Password validation
                if (password === '') {
                    loginPasswordError.text('Password is required.').addClass('text-danger');
                    isValid = false;
                }

                // Proceed if form is valid
                if (isValid) {
                    self.customerLogin();
                }
            });
        }
    }
}
</script>

<style scoped></style>
